import { AvailableLanguageKeys } from 'core/enums/available-language-keys.enum';

export const supportedLanguages: string[] = [AvailableLanguageKeys.en];

export const defaultLanguage = AvailableLanguageKeys.en;
